import React from 'react';
import PropTypes from 'prop-types';
import { Nav, NavItem, UncontrolledTooltip, Button } from 'reactstrap';
import { NavLink, Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import CrmCrossChecksItem from './CrmCrossChecksItem';
import QaReportModal from '../QaReportModal';

const propTypes = {
  tests: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const CrmCrossChecksList = ({ tests, onDelete }) => (
  <div>
    <div className="QaLayout__body__header">
      <Nav pills>
        <NavItem>
          <NavLink
            className="nav-link"
            to="/qa/crm/duplicates"
          >
            Duplicates
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className="nav-link"
            to="/qa/crm/cross-check-tests"
          >
            Cross Checks
          </NavLink>
        </NavItem>
      </Nav>

      <div className="actions">
        <QaReportModal
          title="CRM Cross-Checks Report"
          testType="crm_cross_checks"
          ref={(ref) => { this.modal = ref; }}
        >
          <div className="btn-group" role="group" aria-label="Actions">
            <Link
              to="/qa/crm/cross-check-tests/new"
              className="btn btn-secondary"
              id="new_test"
            >
              <FontAwesomeIcon icon={["far", "plus"]} />
            </Link>
            <UncontrolledTooltip
              placement="top"
              target="new_test"
            >
              Add Test
            </UncontrolledTooltip>

            <Button
              color="secondary"
              id="new_report"
              onClick={() => this.modal.toggle()}
            >
              <FontAwesomeIcon icon={["far", "chart-line"]} />
            </Button>
            <UncontrolledTooltip
              placement="top"
              target="new_report"
            >
              Create Report
            </UncontrolledTooltip>
          </div>
        </QaReportModal>
      </div>
    </div>

    <ul className="CrmDuplicatesList">
      {
        tests.map(test =>
          <CrmCrossChecksItem
            key={test.id}
            test={test}
            onDelete={onDelete}
          />
        )
      }
    </ul>
  </div>
);

CrmCrossChecksList.propTypes = propTypes;

export default CrmCrossChecksList;



// WEBPACK FOOTER //
// ./src/features/qa/CrmCrossChecksContainer/CrmCrossChecksList.js